import { defineStore } from 'pinia'
import api from '@/services/apiService'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    loading: false,
    error: null,
  }),

  getters: {
    isLoggedIn: (state) => !!state.user,
  },

  actions: {
    async login(credentials) {
      this.loading = true
      this.error = null

      try {
        await api.auth.csrf()
        await api.auth.login(credentials)
        await this.fetchUser()
      } catch (err) {
        this.error = err.response?.data?.message || 'Błąd logowania'
        throw err
      } finally {
        this.loading = false
      }
    },

    async logout() {
      await api.auth.logout()
      this.user = null
    },

    async fetchUser() {
      try {
        const res = await api.auth.fetchUser()
        this.user = res.data
      } catch {
        this.user = null
      }
    },
  },
})